//全局变量 lshoot
window.lshoot = window.lshoot || {};
window.lshoot.api = window.lshoot.api || {};
window.lshoot.api.domain = 
'http://test.hk.lshoot.com:90';
//'http://localhost:56976';
//'https://hk.m.lshoot.com/';
// window.lshoot.api.tokenKey = 'lshoot-qupaipai-hk-account-token';
window.lshoot.api.tokenKey = 'lshoot-qupaipai-hk-account-token';
window.lshoot.api = {
    sms: {
        // 发送验证码
        sendCode: window.lshoot.api.domain + '/Api/SMS/SendCode'
    },
    account: {
        // 登录
        login: window.lshoot.api.domain + '/Api/Account/Login',
        // 登出
        logout: window.lshoot.api.domain + '/Api/Account/LogOut',
        // 普通用户注册
        userRegister: window.lshoot.api.domain + '/Api/Account/UserRegister',
        // 摄影师注册
        grapherUserRegister: window.lshoot.api.domain + '/Api/Account/GrapherUserRegister',
        // 摄影师加盟
        grapherAddIn: window.lshoot.api.domain + '/Api/Account/GrapherAddIn',
        // 申请开店
        applyStore: window.lshoot.api.domain + '/Api/Account/ApplyStore',
        // 忘记密码(修改密码)
        modifyPwd: window.lshoot.api.domain + '/Api/Account/ModifyPwd',
        // 获取用户注册状态
        getUserRegisterState: window.lshoot.api.domain + '/Api/Account/GetUserRegisterState'
    },
    sysArea: {
        // 区域数据
        getAllData: window.lshoot.api.domain + '/Api/SysArea/GetAllData'
    },
    upload: {
        // 上传图片（普通）
        Images: window.lshoot.api.domain + '/Api/Upload/Images'
    },
    ossUpload: {
        // 上传图片（OSS）
        Images: window.lshoot.api.domain + '/Api/OssUpload/Images'
    },
    banner: {
        // banner数据列表
        getList: window.lshoot.api.domain + '/Api/Banner/GetList'
    },
    home: {
        // 获取中国所有城市
        getChineseCities: window.lshoot.api.domain + '/Api/Home/GetChineseCities',
        // 获取全球城市
        getGlobalCities: window.lshoot.api.domain + '/Api/Home/GetGlobalCities',
        // 拍摄类型
        getShootTypes: window.lshoot.api.domain + '/Api/Home/GetShootTypes',
        // 首页拍摄案例展示
        getShootCases: window.lshoot.api.domain + '/Api/Home/GetShootCases',
        // 首页推荐套餐
        getProductPackages: window.lshoot.api.domain + '/Api/Home/GetProductPackages'
    },
    product: {
        // 新增产品收藏
        addCollection: window.lshoot.api.domain + '/Api/Product/Collection',
        // 获取产品的收藏状态
        getCollectionState: window.lshoot.api.domain + '/Api/Product/GetCollectionState',
        // 产品列表（分页查询）
        getProductPager: window.lshoot.api.domain + '/Api/Product/GetProductPager',
        // 店铺产品套餐（分页查询）
        getProductPackagePager: window.lshoot.api.domain + '/Api/Product/GetProductPackagePager',
        // 产品套餐详情
        getProductPackageInfo: window.lshoot.api.domain + '/Api/Product/GetProductPackageInfo',
        // 获取产品评论（分页查询）
        getCommentPager: window.lshoot.api.domain + '/Api/Product/GetCommentPager',
        // 获取评论标签统计信息
        getStatisticsByProduct: window.lshoot.api.domain + '/Api/Product/GetStatisticsByProduct',
        // 商家信息接口
        detail: window.lshoot.api.domain + '/Api/Product/StoreDetail',
        // 产品订单统计信息（评论页）
        productOrderStatistics: window.lshoot.api.domain + '/Api/Product/ProductOrderStatistics',
        // 产品套餐列表信息（下单页）
        getProductPackages: window.lshoot.api.domain + '/Api/Product/GetProductPackages',
        // 产品套餐列表信息（下单页，指定优惠码）
        getProductPackagesByPromoCode: window.lshoot.api.domain + '/Api/Product/GetProductPackagesByPromoCode'
    },
    store: {
        // 新增店铺收藏
        addCollection: window.lshoot.api.domain + '/Api/Store/Collection',
        // 店铺列表（分页查询）
        getStorePager: window.lshoot.api.domain + '/Api/Store/GetStorePager',
        // 商家信息接口
        detail: window.lshoot.api.domain + '/Api/Store/Detail',
        // 店铺案例列表（分页查询）
        getShootCasePager: window.lshoot.api.domain + '/Api/Store/GetShootCasePager',
        // 店铺案例下所有图片
        getShootCaseImages: window.lshoot.api.domain + '/Api/Store/GetShootCaseImages',
        // 获取当前登录用户的店铺开店审核状态
        getStoreAuditStatus: window.lshoot.api.domain + '/Api/Store/GetStoreAuditStatus'
    },
    order: {
        //下单接口
        createOrder: window.lshoot.api.domain + '/Api/Order/CreateOrder',
        //获取订单（总费用）信息
        getOrderPrice: window.lshoot.api.domain + '/Api/Order/GetOrderPrice',
        //获取订单（支付状态）信息
        getOrderPayStatus: window.lshoot.api.domain + '/Api/Order/GetOrderPayStatus',
        //订单支付
        pay: window.lshoot.api.domain + '/Api/WechatPay/Pay',
        //订单列表
        getOrderPager: window.lshoot.api.domain + '/Api/Order/GetOrderPager',
        //获取订单（详情）信息
        getOrderInfo: window.lshoot.api.domain + '/Api/Order/GetOrderInfo',
        //获取订单信息（评论页）
        getOrderInfoByComment: window.lshoot.api.domain + '/Api/Order/GetOrderInfoByComment',
        //订单评论
        addOrderComment: window.lshoot.api.domain + '/Api/Order/AddOrderComment',
        //取消订单
        cancelOrder: window.lshoot.api.domain + '/Api/Order/CancelOrder',
        //获取所有需要验收的图片
        getInspectedImages: window.lshoot.api.domain + '/Api/Order/GetInspectedImages',
        //订单验收（所有图片）
        orderInspected: window.lshoot.api.domain + '/Api/Order/OrderInspected',
        //订单图片验收不通过（单张图片）
        orderImageInvalid: window.lshoot.api.domain + '/Api/Order/OrderImageInvalid',
        //订单图片验收通过（单张图片）
        orderImageValid: window.lshoot.api.domain + '/Api/Order/OrderImageValid',
        //获取订单任务图片的下载地址
        getOrderImagesRARLink: window.lshoot.api.domain + '/Api/Order/GetOrderImagesRARLink'
    },
    personal: {
        //我的收藏（分页查询）
        getCollectionPager: window.lshoot.api.domain + '/Api/Personal/GetCollectionPager',
        //我的酒店（分页查询）
        getHotelPager: window.lshoot.api.domain + '/Api/Personal/GetHotelPager',
        //修改密码
        modifyPwd: window.lshoot.api.domain + '/Api/Personal/ModifyPwd',
        //获取用户信息
        getUser: window.lshoot.api.domain + '/Api/Personal/GetUser',
        //更新用户信息
        updateUser: window.lshoot.api.domain + '/Api/Personal/UpdateUser'
    }
};




// WEBPACK FOOTER //
// ./src/assets/js/lsajax.js